import { DataTable, Spinner } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { withCan } from "@src/utils/components/permissions";
import { useUpdateURI } from "@src/utils/hooks/useUpdateURI";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { NavBar, Table } from "./components";
import { useFetchTableData, useSetStoreFromURL } from "./hooks";
import { Context, Store } from "./store";

const UserMonthlyReportList = () => {
  const [store] = useState(() => new Store());

  useSetStoreFromURL(store);

  const tableDataLoading = useFetchTableData(store);

  useUpdateURI(store.urlParams);

  return (
    <Context.Provider value={store}>
      <DataTable>
        {tableDataLoading && <Spinner absolute />}
        <NavBar period={store.period} onChangePeriod={store.setPeriod} />
        <hr />
        <Table rows={store.userMonthlyReportData} />
        <Pagination store={store.pagination} />
      </DataTable>
    </Context.Provider>
  );
};
export default withCan(
  { do: "timeTracking_userMonthlyReport_read" },
  observer(UserMonthlyReportList),
);
